/* Site-Specific JavaScript */
/* Site-Specific JavaScript */
jq(document).ready(() => {
    // Find all .bg-wrapper-start elements
    const startElements = document.querySelectorAll('.bg-wrapper-start');
    
    startElements.forEach(startEl => {
        // Find the corresponding .bg-wrapper-end element
        let currentEl = startEl.nextElementSibling;
        const elementsToWrap = [startEl];
        let endEl = null;
        
        // Collect all elements between start and end
        while (currentEl) {
            elementsToWrap.push(currentEl);
            
            if (currentEl.classList.contains('bg-wrapper-end')) {
                endEl = currentEl;
                break;
            }
            
            currentEl = currentEl.nextElementSibling;
        }
        
        // Only wrap if we found a matching end element
        if (endEl && elementsToWrap.length > 0) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('bg-wrap');
            
            // Insert wrapper before the first element
            startEl.parentNode.insertBefore(wrapper, startEl);
            
            // Move all elements into the wrapper
            elementsToWrap.forEach(el => {
                wrapper.appendChild(el);
            });
        }
    });

    // Media listing gallery filters
    const filterForm = document.querySelector('.redirect-select');
    if (filterForm) {
        // Handle form submission
        filterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const formData = new FormData(filterForm);
            const params = new URLSearchParams();
            
            // Add non-empty form values to URL params
            for (const [key, value] of formData) {
                if (value) {
                    params.append(key, value);
                }
            }
            
            // Redirect to the current page with query parameters
            const url = params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
            window.location.href = url;
        });
        
        // Handle clear filters button
        const clearBtn = document.getElementById('clear-filter-btn');
        if (clearBtn) {
            clearBtn.addEventListener('click', function(e) {
                e.preventDefault();
                // Redirect to page without query parameters
                window.location.href = window.location.pathname;
            });
        }
    }

    // Media Assets filters: auto-apply on checkbox change. The form is a
    // plain GET form, so submitting rebuilds the URL params (shareable /
    // bookmarkable) and resets pagination server-side.
    const assetFilters = document.querySelector('.media-assets-filters');
    if (assetFilters) {
        assetFilters.addEventListener('change', function (e) {
            if (e.target.matches('input[type="checkbox"]')) {
                try { sessionStorage.setItem('newsroomFilterFocus', e.target.id); } catch (err) {}
                assetFilters.submit();
            }
        });
    }

    // Newsroom listing filters: selecting a Category/Year applies immediately
    // (the form is the .redirect-select GET form, so the URL stays shareable).
    // The applying reload would otherwise drop keyboard focus back to the top
    // of the page (WAI-ARIA select-only combobox expectation: focus stays on
    // the control) - remember the control and restore focus after the reload.
    const newsroomFilters = document.querySelector('.media-listing-filters');
    if (newsroomFilters) {
        newsroomFilters.addEventListener('change', function (e) {
            if (e.target.matches('select')) {
                try { sessionStorage.setItem('newsroomFilterFocus', e.target.id); } catch (err) {}
                newsroomFilters.dispatchEvent(new Event('submit', { cancelable: true }));
            }
        });
    }

    // Same for the Media Assets filter checkboxes
    try {
        const restoreFocusId = sessionStorage.getItem('newsroomFilterFocus');
        if (restoreFocusId) {
            sessionStorage.removeItem('newsroomFilterFocus');
            const restoreEl = document.getElementById(restoreFocusId);
            if (restoreEl) {
                restoreEl.focus();
            }
        }
    } catch (err) {}

    // Newsroom listing w/ search: the third-party-sharing disclaimer must sit
    // directly under the search box, which the Elastic app renders after
    // load - relocate it once the app mounts.
    const searchDisclaimer = document.querySelector('.media-listing-search .search-disclaimer');
    if (searchDisclaimer) {
        const relocate = setInterval(function () {
            const searchBox = document.querySelector('.media-listing-search .sui-search-box');
            if (searchBox) {
                searchBox.insertAdjacentElement('afterend', searchDisclaimer);
                clearInterval(relocate);
            }
        }, 150);
        setTimeout(function () { clearInterval(relocate); }, 10000);
    }
});

// Handle focusable content for news slider (standard and --ir)
const newsSliderContainerSelector = '.module-latest-news-slider, .module-latest-news-slider--ir';

function initNewsSliderAccessibility() {
    if (!jq(newsSliderContainerSelector + ' .news-slider').length) {
        return;
    }

    function updateNewsSliderAccessibility() {
        jq(newsSliderContainerSelector).each(function() {
            const $sliderContainer = jq(this);
            const $slider = $sliderContainer.find('.news-slider');
            if (!$slider.length || !$slider.hasClass('slick-initialized')) {
                return;
            }

            // Handle hidden container - set tabindex="-1" on all focusable content when hidden
            const $hiddenContainer = $sliderContainer.find('.hidden-xs.hidden-sm, [style*="display: none"], [aria-hidden="true"]');
            $hiddenContainer.each(function() {
                const $container = jq(this);
                const isVisible = $container.is(':visible') && $container.css('display') !== 'none';
                if (!isVisible) {
                    const focusableElements = $container.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    focusableElements.attr('tabindex', '-1');
                }
            });

            // Handle slides - set tabindex="-1" on hidden/cloned slides
            $slider.find('.slick-slide').each(function() {
                const $slide = jq(this);
                const isVisible = $slide.hasClass('slick-active') && !$slide.hasClass('slick-cloned');
                const isHidden = $slide.hasClass('slick-cloned') ||
                    ($slide.css('display') === 'none') ||
                    ($slide.attr('aria-hidden') === 'true');

                const focusableElements = $slide.find('a, button, input, select, textarea, [tabindex]');
                focusableElements.each(function() {
                    if (isHidden || !isVisible) {
                        jq(this).attr('tabindex', '-1').prop('tabIndex', -1);
                    } else {
                        const currentTabindex = jq(this).attr('tabindex');
                        if (currentTabindex === '-1') {
                            jq(this).removeAttr('tabindex');
                            if (jq(this).is('a, button, input, select, textarea')) {
                                jq(this).prop('tabIndex', 0);
                            }
                        }
                    }
                });
            });

            // Dots: all focusable so Tab from last slide item can go to dots; aria-selected reflects current slide
            const $dots = $sliderContainer.find('.slider-nav .eq-dots .slick-dots li');
            $dots.each(function() {
                const $dot = jq(this);
                const $btn = $dot.find('button');
                const isActive = $dot.hasClass('slick-active') && $dot.hasClass('active');
                $btn.attr('aria-selected', isActive ? 'true' : 'false');
                $btn.attr('tabindex', '0');
            });

            // Navigation buttons - only focusable when slider visible
            const $navButtons = $sliderContainer.find('.slider-nav button');
            const $sliderWrapper = $sliderContainer.find('.hidden-xs.hidden-sm');
            if ($sliderWrapper.length && !$sliderWrapper.is(':visible')) {
                $navButtons.attr('tabindex', '-1');
            } else {
                $navButtons.removeAttr('tabindex');
            }
        });
    }

    function updateNewsSliderPageNums(evt, slick) {
        const $slider = jq(evt.target || slick.$slider);
        const $sliderContainer = $slider.closest(newsSliderContainerSelector);
        $sliderContainer.find('.current-slide-num').text(slick.currentSlide + 1);
    }

    function setTotalSlideNum() {
        jq(newsSliderContainerSelector).each(function() {
            const container = this;
            const slides = container.querySelectorAll('.slick-slide:not(.slick-cloned)');
            const totalEl = container.querySelector('.total-slide-num');
            if (totalEl) {
                totalEl.innerText = slides.length;
            }
        });
    }

    // Re-apply tabindex when focus enters slider so hidden slides stay non-tabbable (e.g. after clicking a dot)
    function bindNewsSliderFocusSync() {
        jq(newsSliderContainerSelector).on('focusin', function() {
            updateNewsSliderAccessibility();
        });
    }

    // Tab: from last visible focusable -> go to active dot. Shift+Tab: from first visible focusable -> go to active dot (so focus doesn't go to hidden slides)
    function setupNewsSliderFocusRedirect() {
        const selector = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
        jq(newsSliderContainerSelector).on('keydown', function(evt) {
            if (evt.key !== 'Tab') {
                return;
            }
            const activeEl = document.activeElement;
            const $container = jq(this);
            if (!activeEl || !$container[0].contains(activeEl)) {
                return;
            }
            const $slider = $container.find('.news-slider');
            const $visibleSlides = $slider.find('.slick-slide.slick-active:not(.slick-cloned)');
            const allFocusables = [];
            $visibleSlides.each(function() {
                const $slide = jq(this);
                $slide.find(selector).filter(function() {
                    return jq(this).is(':visible') && (this.tabIndex >= 0 || this.tagName === 'A' || this.tagName === 'BUTTON');
                }).each(function() {
                    allFocusables.push(this);
                });
            });
            const firstInAllVisible = allFocusables[0];
            const lastInAllVisible = allFocusables[allFocusables.length - 1];
            const $activeDot = $container.find('.slider-nav .eq-dots .slick-dots li.slick-active.active button');

            if (evt.shiftKey) {
                // Shift+Tab from first visible focusable -> go to active dot (avoid focus going to hidden cards)
                if (firstInAllVisible && firstInAllVisible === activeEl && $activeDot.length) {
                    evt.preventDefault();
                    $activeDot[0].focus();
                }
            } else {
                // Tab from last visible focusable -> go to active dot
                if (lastInAllVisible && lastInAllVisible === activeEl && $activeDot.length) {
                    evt.preventDefault();
                    $activeDot[0].focus();
                }
            }
        });
    }

    // Re-apply match height after Slick init so cloned slides are included (avoids race where matchHeight ran before Slick)
    function updateNewsSliderMatchHeight() {
        if (typeof jq.fn.matchHeight !== 'function') {
            return;
        }
        const $containers = jq(newsSliderContainerSelector);
        $containers.each(function() {
            const $container = jq(this);
            if (!$container.find('.news-slider.slick-initialized').length) {
                return;
            }
            const selector = '[data-mh="news-text-box"]';
            const $existing = $container.find(selector);
            if (!$existing.length) {
                return;
            }
            $existing.matchHeight('remove');
            $container.find(selector).matchHeight(true);
        });
    }

    function initWhenReady() {
        updateNewsSliderAccessibility();
        setTotalSlideNum();
        bindNewsSliderFocusSync();
        setupNewsSliderFocusRedirect();
        updateNewsSliderMatchHeight();
        jq(window).on('load', updateNewsSliderMatchHeight);
        jq(newsSliderContainerSelector + ' .news-slider').on('afterChange', function(evt, slick) {
            updateNewsSliderAccessibility();
            updateNewsSliderPageNums(evt, slick);
        });
    }

    if (typeof waitForElm !== 'undefined') {
        waitForElm(newsSliderContainerSelector + ' .news-slider.slick-initialized').then(initWhenReady);
    } else {
        jq(document).ready(function() {
            const checkSlider = setInterval(function() {
                if (jq(newsSliderContainerSelector + ' .news-slider.slick-initialized').length) {
                    clearInterval(checkSlider);
                    initWhenReady();
                }
            }, 100);
        });
    }
}

// Initialize news slider accessibility on document ready
jq(document).ready(function() {
    initNewsSliderAccessibility();
});

/**
 * QuoteMedia chart period buttons ship with aria-label=time.name (e.g. "1 Day")
 * while the visible text is time.label (e.g. "1D") and is aria-hidden. That
 * fails WCAG 2.5.3 Label in Name. Prefix the visible label when a leftover
 * aria-label does not already contain it. The template also drops the
 * override so content can supply the name.
 */
function prefixQmodChartPeriodLabels() {
    document.querySelectorAll('.qmod-group-btn[aria-label]').forEach(function (btn) {
        const visibleEl = btn.querySelector('.qmod-btn-text');
        const visible = ((visibleEl && visibleEl.textContent) || '').trim();
        const name = (btn.getAttribute('aria-label') || '').trim();
        if (!visible || !name) {
            return;
        }
        if (name.toLowerCase().indexOf(visible.toLowerCase()) !== -1) {
            return;
        }
        btn.setAttribute('aria-label', visible + ' ' + name);
    });
}

function initQmodChartPeriodLabelFix() {
    if (!document.querySelector('.qtool, .qmod-group-btn-ul')) {
        return;
    }
    prefixQmodChartPeriodLabels();
    const root = document.querySelector('.detailed-quote, .qmod-ui-tool') || document.body;
    const observer = new MutationObserver(function () {
        prefixQmodChartPeriodLabels();
    });
    observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label']
    });
}

jq(document).ready(function () {
    initQmodChartPeriodLabelFix();
});